// side effect: start session when featureModel changes
import {setProductModel} from '../slices/configurationSlice';
import {fetchModels} from '../slices/productDataSlice';

export const modeMiddleware = store => next => async action => {
	const result = next(action); // execute middleware after action

	if (action.type === 'status/setMode') {
		if (store.getState().status?.productFamily) {
			await store.dispatch(fetchModels());

			// use default model
			let loadedProductModelId = store.getState().configuration?.data?.projects && store.getState().configuration?.data?.projects[0].project?.productModelId;
			if (loadedProductModelId === '') {
				loadedProductModelId = undefined;
			}
			const defaultProductModel = store.getState().productData.models.find(m => m.isDefault);
			const firstProductModel = store.getState().productData.models[0];
			await store.dispatch(setProductModel({
				productModel: loadedProductModelId ?? defaultProductModel?.productModelId ?? firstProductModel?.productModelId
			}));
		}
	}

	return result;
};
